$(document).ready(function(){

  $(".collection-tabs li").click(function(){
    const id = $(this).data('id');
    const $slider = $("#Slider-" + id);
    const $parent = $(this).closest('.antr--collection-tabs');

    $slider.parents('.collection').find(".contains-card").removeClass('active');
    $slider.addClass('active');

    $parent.find(".collection-tabs li").removeClass('active');
    $(this).addClass('active');
  
    $parent.find(".contains-card--product").hide().css('opacity', 0);
    
    $slider.show().slick('refresh');

    setTimeout(() => $slider.css('opacity', 1), 500);
  });

  $(".collapsibles_tab .product__accordion-heading").click(function () {
    const $parent = $(this).closest(".collapsibles_tab");
    const $content = $parent.find(".accordion__contents");

    $(".collapsibles_tab").not($parent).removeClass("active")
      .find(".accordion__contents").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });


  $(".footer-block .footer-block__heading").click(function () {
    const $parent = $(this).closest(".footer-block");
    const $content = $parent.find(".footer-block__details-content");

    $(".footer-block").not($parent).removeClass("active")
      .find(".footer-block__details-content").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });
  
});